module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-lg-offset-1 col-md-6 col-sm-12"
  }, [_c('h2', [_vm._v("\n        Dokumenter\n    ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "40px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('document', {
    attrs: {
      "title": "Kontrolrapport",
      "issuer": "Fødevarestyrelsen",
      "link": "/static/images/kontrolrapport.pdf"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-123ac228"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/documents.vue
// module id = 252
// module chunks = 1